// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#reciepe-Modal___BV_modal_content_,.b-overlay-wrap{min-height:200px}", ""]);
// Exports
module.exports = exports;
